import {
    INSERT_REPORT_ITEM,
    INTRO_NEXT_STEP,
    WEBCAM_NEXT_STEP,
    MICROPHONE_NEXT_STEP,
    SPEAKER_NEXT_STEP,
    WEBRTC_NEXT_STEP,
    GO_TO_WEBCAM,
    GO_TO_MICROPHONE,
    GO_TO_SPEAKER,
    GO_TO_WEBRTC,
    GO_TO_REPORT,
    WEBCAM_RESET,
    MICRO_RESET,
    RUN_CONFORMITY,
    RESET_CONFORMITY,
    WEBRTC_P2P_OK,
} from '../actions/types'
import { STEP_INTRO, STEP_WEBCAM, STEP_MICRO, STEP_REPORT, STEP_SPEAKER, STEP_WEBRTC } from '../../utils/constants'
import { Report } from '../../components/features/conformity/_props'

interface ConformityStore {
    completed: number
    step: string
    report: Report[]
    introStep: number
    webcamStep: number
    microphoneStep: number
    speakerStep: number
    webrtcStep: number
    isRelayCheckNeeded: boolean
    totalStepCount: number
    bandwidthMeasure: Array<any>
    runConformity: any
}

const INITIAL_STATE: ConformityStore = {
    completed: 0,
    step: STEP_INTRO,
    report: [],
    introStep: 0,
    webcamStep: 0,
    microphoneStep: 0,
    speakerStep: 0,
    webrtcStep: 0,
    isRelayCheckNeeded: true,
    totalStepCount: 13,
    bandwidthMeasure: [],
    runConformity: undefined,
}

export default (state = INITIAL_STATE, action: any): ConformityStore => {
    let newReport: Report[] = []
    let newCompleted = 0
    switch (action.type) {
        case INSERT_REPORT_ITEM:
            newReport = state.report.slice()
            newReport.push(action.payload)
            return {
                ...state,
                report: newReport,
            }
        case INTRO_NEXT_STEP:
            newCompleted = Math.floor(
                ((state.introStep +
                    state.webcamStep +
                    state.microphoneStep +
                    state.speakerStep +
                    state.webrtcStep +
                    1) /
                    state.totalStepCount) *
                    100
            )
            return {
                ...state,
                introStep: state.introStep + 1,
                completed: newCompleted,
            }
        case WEBCAM_NEXT_STEP:
            newCompleted = Math.floor(
                ((state.introStep +
                    state.webcamStep +
                    state.microphoneStep +
                    state.speakerStep +
                    state.webrtcStep +
                    1) /
                    state.totalStepCount) *
                    100
            )
            return {
                ...state,
                webcamStep: state.webcamStep + 1,
                completed: newCompleted,
            }
        case MICROPHONE_NEXT_STEP:
            newCompleted = Math.floor(
                ((state.introStep +
                    state.webcamStep +
                    state.microphoneStep +
                    state.speakerStep +
                    state.webrtcStep +
                    1) /
                    state.totalStepCount) *
                    100
            )
            return {
                ...state,
                microphoneStep: state.microphoneStep + 1,
                completed: newCompleted,
            }
        case SPEAKER_NEXT_STEP:
            newCompleted = Math.floor(
                ((state.introStep +
                    state.webcamStep +
                    state.microphoneStep +
                    state.speakerStep +
                    state.webrtcStep +
                    1) /
                    state.totalStepCount) *
                    100
            )
            return {
                ...state,
                speakerStep: state.speakerStep + 1,
                completed: newCompleted,
            }
        case WEBRTC_NEXT_STEP:
            newCompleted = Math.floor(
                ((state.introStep +
                    state.webcamStep +
                    state.microphoneStep +
                    state.speakerStep +
                    state.webrtcStep +
                    1) /
                    state.totalStepCount) *
                    100
            )
            return {
                ...state,
                webrtcStep: state.webrtcStep + 1,
                completed: newCompleted,
            }
        case WEBRTC_P2P_OK: // No need to check relay mode
            newCompleted = Math.floor(
                ((state.introStep +
                    state.webcamStep +
                    state.microphoneStep +
                    state.speakerStep +
                    state.webrtcStep +
                    2) /
                    state.totalStepCount) *
                    100
            )
            return {
                ...state,
                webrtcStep: state.webrtcStep + 2,
                completed: newCompleted,
                isRelayCheckNeeded: false,
            }
        case GO_TO_WEBCAM:
            newCompleted = Math.floor(
                ((state.introStep +
                    state.webcamStep +
                    state.microphoneStep +
                    state.speakerStep +
                    state.webrtcStep +
                    1) /
                    state.totalStepCount) *
                    100
            )
            return {
                ...state,
                step: STEP_WEBCAM,
                introStep: state.webcamStep + 1,
                completed: newCompleted,
            }
        case GO_TO_MICROPHONE:
            newCompleted = Math.floor(
                ((state.introStep +
                    state.webcamStep +
                    state.microphoneStep +
                    state.speakerStep +
                    state.webrtcStep +
                    1) /
                    state.totalStepCount) *
                    100
            )
            return {
                ...state,
                step: STEP_MICRO,
                webcamStep: state.webcamStep + 1,
                completed: newCompleted,
            }
        case GO_TO_SPEAKER:
            newCompleted = Math.floor(
                ((state.introStep +
                    state.webcamStep +
                    state.microphoneStep +
                    state.speakerStep +
                    state.webrtcStep +
                    1) /
                    state.totalStepCount) *
                    100
            )
            return {
                ...state,
                step: STEP_SPEAKER,
                microphoneStep: state.microphoneStep + 1,
                completed: newCompleted,
            }
        case GO_TO_WEBRTC:
            newCompleted = Math.floor(
                ((state.introStep +
                    state.webcamStep +
                    state.microphoneStep +
                    state.speakerStep +
                    state.webrtcStep +
                    1) /
                    state.totalStepCount) *
                    100
            )
            return {
                ...state,
                step: STEP_WEBRTC,
                speakerStep: state.speakerStep + 1,
                completed: newCompleted,
            }
        case GO_TO_REPORT:
            return {
                ...state,
                step: STEP_REPORT,
                completed: 100,
            }
        case WEBCAM_RESET:
            return {
                ...state,
                webcamStep: 0,
                completed: 0,
            }
        case MICRO_RESET:
            newCompleted = Math.floor(
                ((state.introStep +
                    state.webcamStep +
                    state.microphoneStep +
                    state.speakerStep +
                    state.webrtcStep +
                    1) /
                    state.totalStepCount) *
                    100
            )
            return {
                ...state,
                microphoneStep: 0,
                completed: newCompleted,
            }
        case RUN_CONFORMITY:
            return {
                ...state,
                runConformity: action.payload.open,
            }
        case RESET_CONFORMITY:
            return {
                ...INITIAL_STATE,
            }
        default:
            return state
    }
}
